/*
IMPORTANT
This file is auto-generated.
Do not make manual changes.
Manual changes will be overwritten when the file is next generated.

API:          EM Service WebEntry API
Version:      2
Description:  Event Management Service WebEntry API provides all the Event and Data related calls for web entry.
Generated at: 23-06-2025 15:19 (India Standard Time)
*/

import axios, { AxiosError, AxiosResponse } from 'axios';
import { ApiError } from '../Providers.Api/ApiError';
import { ODataSelect } from '../Providers.Api/ODataQuery';
import { IRawPagedResponse, IRawPagedResponse3, PagedResponse } from '../Providers.Api/Models';
import { ApiHelper } from '../Providers.Api/ApiHelper';
import { IbssRequestConfig } from '../Providers.Api/ApiClient';

export interface IContext
{
    baseUrl: string;
}

export interface IEmServiceWebEntryApiClientV2
{
    v2: IEmServiceWebEntryApiClientV2_V2;


}

export class EmServiceWebEntryApiClientV2 implements IEmServiceWebEntryApiClientV2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.v2 = new EmServiceWebEntryApiClientV2_V2(context);
    }

    public v2: EmServiceWebEntryApiClientV2_V2;


}

export interface IEmServiceWebEntryApiClientV2_V2
{
    byNodeid: IEmServiceWebEntryApiClientV2_V2_ByNodeid;


}

export class EmServiceWebEntryApiClientV2_V2 implements IEmServiceWebEntryApiClientV2_V2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byNodeid = new EmServiceWebEntryApiClientV2_V2_ByNodeid(context);
    }

    public byNodeid: EmServiceWebEntryApiClientV2_V2_ByNodeid;


}

export interface IEmServiceWebEntryApiClientV2_V2_ByNodeid
{
    bookingPolicies: IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies;


}

export class EmServiceWebEntryApiClientV2_V2_ByNodeid implements IEmServiceWebEntryApiClientV2_V2_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bookingPolicies = new EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies(context);
    }

    public bookingPolicies: EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies;


}

export interface IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies
{
    byBookingpolicyid: IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IBookingPolicy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies implements IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byBookingpolicyid = new EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid(context);
    }

    public byBookingpolicyid: EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/BookingPolicies?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IBookingPolicy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/BookingPolicies?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid
{
    apply: IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid_Apply;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, bookingpolicyid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, bookingpolicyid: string, body: IBookingPolicy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { nodeId: number, bookingpolicyid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid implements IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.apply = new EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid_Apply(context);
    }

    public apply: EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid_Apply;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, bookingpolicyid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/BookingPolicies/${options.bookingpolicyid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, bookingpolicyid: string, body: IBookingPolicy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/BookingPolicies/${options.bookingpolicyid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { nodeId: number, bookingpolicyid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/BookingPolicies/${options.bookingpolicyid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid_Apply
{

    patch<TResponse>(options: { nodeId: number, bookingpolicyid: string, body: IBookingPolicyApply, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid_Apply implements IEmServiceWebEntryApiClientV2_V2_ByNodeid_BookingPolicies_ByBookingpolicyid_Apply
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, bookingpolicyid: string, body: IBookingPolicyApply, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/BookingPolicies/${options.bookingpolicyid}/Apply?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IBookingPolicy
{
    node_Id?: number;
    booking_Policy_Name?: string | null;
    booking_Policy?: IBookingPolicyVM;

}

export interface IBookingPolicyVM
{
    policyType?: string | null;
    buildingId?: string | null;
    floorId?: string | null;
    allowed_TimeRange?: string | null;
    booking_Policy_Description?: string | null;
    bookingSlots?: IBookingSlots;
    arrivalPolicies?: IArrivalPolicies;
    approvalPolicies?: IApprovalPolicies;
    extendedServices?: IExtendedServices;
    bookingAttendanceControl?: string | null;

}

export interface IBookingSlots
{
    bookableTime?: IBookableTime[] | null;
    excludedDates?: IExcludedDate[] | null;
    bookingStart?: IBookingStart;
    bookingEnd?: IBookingEnd;
    bookingSetupTime?: number;
    bookingTearDownTime?: number;
    bookingDuration?: IBookingDuration;
    bookingHorizon?: IBookingHorizon;
    bookingRecurrence?: IBookingRecurrence;

}

export interface IBookableTime
{
    days?: string[] | null;
    startTime?: string | null;
    endTime?: string | null;

}

export interface IExcludedDate
{
    reason?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    startTime?: string | null;
    endTime?: string | null;

}

export interface IBookingStart
{
    specificMinutes?: string[] | null;
    specificTimes?: string[] | null;

}

export interface IBookingEnd
{
    specificMinutes?: string[] | null;
    specificTimes?: string[] | null;

}

export interface IBookingDuration
{
    minimum?: number;
    maximum?: number;
    fixed?: string[] | null;

}

export interface IBookingHorizon
{
    minimum?: number;
    maximum?: number;
    bookingOffset?: string | null;

}

export interface IBookingRecurrence
{
    maximum?: number;
    allowed?: boolean;

}

export interface IArrivalPolicies
{
    autoCheckin?: boolean;
    earlyCheckin?: number;
    autoCancellation?: number;

}

export interface IApprovalPolicies
{
    approvalRequired?: boolean;
    autoRejectionAfter?: number;
    approvalGroups?: string[] | null;

}

export interface IExtendedServices
{
    spaceSetupManagement?: ISpaceSetupManagement;
    cateringManagement?: ICateringManagement;

}

export interface ISpaceSetupManagement
{
    managementType?: string | null;
    user?: string[] | null;
    group?: string[] | null;

}

export interface ICateringManagement
{
    managementType?: string | null;
    user?: string[] | null;
    group?: string[] | null;

}

export interface IBookingPolicyApply
{
    spaceIds?: string[] | null;

}
